var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"question-id"},[_vm._v("\n    Q"+_vm._s(_vm.id)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }